var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFinderIco(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.99316 0.88623C8.71707 0.88623 10.3704 1.57105 11.5894 2.79004C12.8083 4.00902 13.4932 5.66232 13.4932 7.38623C13.4932 8.99623 12.9032 10.4762 11.9332 11.6162L12.2032 11.8862H12.9932L17.9932 16.8862L16.4932 18.3862L11.4932 13.3862V12.5962L11.2232 12.3262C10.0437 13.333 8.54387 13.8861 6.99316 13.8862C5.26926 13.8862 3.61596 13.2014 2.39697 11.9824C1.17798 10.7634 0.493164 9.11014 0.493164 7.38623C0.493164 5.66232 1.17798 4.00902 2.39697 2.79004C3.61596 1.57105 5.26926 0.88623 6.99316 0.88623ZM6.99316 2.88623C4.49316 2.88623 2.49316 4.88623 2.49316 7.38623C2.49316 9.88623 4.49316 11.8862 6.99316 11.8862C9.49316 11.8862 11.4932 9.88623 11.4932 7.38623C11.4932 4.88623 9.49316 2.88623 6.99316 2.88623Z",
    fill: "#595454"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinderIco);
export default __webpack_public_path__ + "static/media/finderIco.64c236c7fe184d0a3515111de9625a77.svg";
export { ForwardRef as ReactComponent };